import React from 'react';
import Checkbox from '../../components/Checkbox/Checkbox.jsx';
import styles from '../rjsf.module.css';

const CheckboxWidget = ({ id, value, disabled, readonly, label, hideLabel, onChange }) => (
  <label className={styles.checkboxWidgetLabel}>
    <Checkbox
      id={id}
      checked={!!value}
      disabled={disabled || readonly}
      onChange={() => onChange(!value)}
      style={{ padding: 0 }}
    />
    {!hideLabel && label}
  </label>
);

export default CheckboxWidget;
